import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRightIcon, LockIcon, MailIcon } from 'lucide-react';
import { useApp } from '../contexts/AppContext';
import { Logo, Waves } from '../components/ui/Logo';
import { Button } from '../components/ui/Button';
import { inputClass } from '../components/ui/Field';
import { DEMO_ADMIN, DEMO_CLAN, DEMO_GOST } from '../data/members';
import type { Role } from '../types';
const profili: {
  role: Role;
  memberId: string;
  ime: string;
  opis: string;
  email: string;
}[] = [{
  role: 'clan',
  memberId: DEMO_CLAN,
  ime: 'Judita Volčanšek',
  opis: 'Aktivna članica · 1. sopran',
  email: 'judita.volcansek@mepz-viva.si'
}, {
  role: 'gost',
  memberId: DEMO_GOST,
  ime: 'Veronika Strnad',
  opis: 'Gostujoča članica · 2. sopran',
  email: 'veronika.strnad@mepz-viva.si'
}, {
  role: 'vodstvo',
  memberId: DEMO_ADMIN,
  ime: 'Krištof Strnad',
  opis: 'Dirigent · vodstvo zbora',
  email: 'kristof.strnad@mepz-viva.si'
}];
export function Login() {
  const {
    login,
    settings
  } = useApp();
  const navigate = useNavigate();
  const [izbran, setIzbran] = useState(0);
  const [geslo, setGeslo] = useState('••••••••');
  const [email, setEmail] = useState(profili[0].email);
  const [sporocilo, setSporocilo] = useState<string | null>(null);
  const profil = profili[izbran];
  function izberi(i: number) {
    setIzbran(i);
    setEmail(profili[i].email);
  }
  function submit(e: React.FormEvent) {
    e.preventDefault();
    login(profil.role, profil.memberId);
    navigate(profil.role === 'vodstvo' ? '/admin' : '/clan');
  }
  return <div className="flex min-h-full w-full flex-col bg-white lg:flex-row" data-id="element-1291" data-mp="3k57vduxy8mb9">
      <div className="relative flex flex-col justify-between overflow-hidden bg-green-700 px-6 py-10 lg:w-[44%] lg:px-14 lg:py-14" data-id="element-1292" data-mp="3f7ofkqlls1h7">
        <Waves className="absolute inset-x-0 top-1/3 h-56 w-full" color="#ffffff" opacity={0.18} data-id="element-1293" data-mp="1pryrqjs33v0x" />
        <div className="relative" data-id="element-1294" data-mp="1kugfajeuyxo6">
          <Logo variant="dark" className="h-14 lg:h-16" data-id="element-1295" data-mp="2ah12lxy5n779" />
        </div>
        <div className="relative mt-10 lg:mt-0" data-id="element-1296" data-mp="2aiubzl05k5iy">
          <h1 className="max-w-sm text-2xl font-semibold leading-snug text-white lg:text-3xl" data-id="element-1297" data-mp="2ehl052mn4ctx">
            Interni portal zbora VIVA Brežice
          </h1>
          <p className="mt-3 max-w-sm text-[15px] leading-relaxed text-green-50/85" data-id="element-1298" data-mp="2jjsefyuy04zf">
            Vaje, nastopi, prisotnost, obvestila in gradiva — vse na enem mestu, za člane in vodstvo.
          </p>
          <p className="mt-8 text-sm italic text-green-100/80" data-id="element-1299" data-mp="2tdsqkkon6ahn">{settings.slogan}</p>
        </div>
      </div>

      <div className="flex flex-1 items-center justify-center px-6 py-12 lg:px-10" data-id="element-1300" data-mp="327xbyol0atps">
        <div className="w-full max-w-sm" data-id="element-1301" data-mp="32a9ub2uof63d">
          <h2 className="text-xl font-semibold text-ink" data-id="element-1302" data-mp="377a0revfuav0">Prijava</h2>
          <p className="mt-1 text-sm text-ink-muted" data-id="element-1303" data-mp="3c63hdg60uhze">Vpišite se s svojim zborovskim e-naslovom.</p>

          <form onSubmit={submit} className="mt-7 space-y-4" data-id="element-1304" data-mp="3h57p02das7nm">
            <div data-id="element-1305" data-mp="3h5g13s1lj8xr">
              <label htmlFor="email" className="mb-1.5 block text-[13px] font-medium text-ink" data-id="element-1306" data-mp="3h2tubumj4xgl">
                E-naslov
              </label>
              <div className="relative" data-id="element-1307" data-mp="10ii1p5j2p4ym">
                <MailIcon className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-ink-muted" data-id="element-1308" data-mp="10hgigdrwlc5t" />
                <input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} className={`${inputClass} pl-9`} data-id="element-1309" data-mp="qklj5snt37qh" />
              </div>
            </div>

            <div data-id="element-1310" data-mp="1jbc6j6mzfgp4">
              <label htmlFor="geslo" className="mb-1.5 block text-[13px] font-medium text-ink" data-id="element-1311" data-mp="1eij3cn75wgf5">
                Geslo
              </label>
              <div className="relative" data-id="element-1312" data-mp="19ieof1lwjtr1">
                <LockIcon className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-ink-muted" data-id="element-1313" data-mp="19hlnih9mjygt" />
                <input id="geslo" type="password" value={geslo} onChange={e => setGeslo(e.target.value)} className={`${inputClass} pl-9`} data-id="element-1314" data-mp="228dduy40dsw8" />
              </div>
            </div>

            <div className="flex items-center justify-between pt-1" data-id="element-1315" data-mp="1crxpmxvnxrlv">
              <label className="flex items-center gap-2 text-[13px] text-ink-muted" data-id="element-1316" data-mp="1ctqymjtr0nx1">
                <input type="checkbox" defaultChecked className="h-4 w-4 rounded border-line accent-green-500" data-id="element-1317" data-mp="1hrsjnaaqixb5" />
                Ostani prijavljen
              </label>
              <button type="button" onClick={() => setSporocilo('Navodila za ponastavitev gesla smo poslali na vaš e-naslov.')} className="text-[13px] font-medium text-green-600 hover:underline" data-id="element-1318" data-mp="2ag7wbq6e93jb">
                Pozabljeno geslo?
              </button>
            </div>

            {sporocilo && <p role="status" className="rounded-lg border border-green-200 bg-green-50 px-3 py-2.5 text-[13px] text-green-800" data-id="element-1319" data-mp="2odmnazcapjde">
                {sporocilo}
              </p>}

            <Button type="submit" full size="lg" className="mt-2" data-id="element-1320" data-mp="csvvkq7kk9as">
              Prijava
              <ArrowRightIcon className="h-4 w-4" data-id="element-1321" data-mp="rhiaiqtaaz1h" />
            </Button>
          </form>

          <div className="mt-8 border-t border-line pt-6" data-id="element-1322" data-mp="mi5ou9e5fy0h">
            <p className="text-[11px] font-semibold uppercase tracking-wide text-ink-muted" data-id="element-1323" data-mp="mip5znvz6idg">
              Predstavitveni profili
            </p>
            <div className="mt-3 space-y-2" data-id="element-1324" data-mp="3pz5pwq9mv8eq">
              {profili.map((p, i) => <button key={p.memberId} type="button" onClick={() => izberi(i)} aria-pressed={izbran === i} className={`flex w-full items-center justify-between gap-3 rounded-lg border px-3 py-2.5 text-left transition-colors duration-150 ease-out ${izbran === i ? 'border-green-300 bg-green-50' : 'border-line bg-white hover:bg-canvas'}`} data-id="element-1325" data-mp="7t11yewet5m1" data-mpi={i}>
                  <span data-id="element-1326" data-mp="gtp7r6lrvtm9">
                    <span className="block text-sm font-medium text-ink" data-id="element-1327" data-mp="gt74hq0p0f4u">{p.ime}</span>
                    <span className="block text-xs text-ink-muted" data-id="element-1328" data-mp="lv65it8ymzym">{p.opis}</span>
                  </span>
                  <span className={`h-4 w-4 shrink-0 rounded-full border-[5px] ${izbran === i ? 'border-green-500 bg-white' : 'border-line bg-white'}`} data-id="element-1329" data-mp="puwtyqb0l3zz" />
                </button>)}
            </div>
          </div>
        </div>
      </div>
    </div>;
}